<div id="home-page">

    
    <div class="container mt-5"> 

        <h4>Ma liste de tâches </h4>

        
        <form name="userForm" role="form"  [formGroup]="userForm" *ngIf='isAdmin'>
            <mat-form-field class=""  appearance="outline">
                <mat-label>Voir en tant que :</mat-label>
                <select matNativeControl formControlName="user" (change)="changeUser()">
                    <option value="" ></option>
                    <option [value]="utilisateur.id" *ngFor="let utilisateur of utilisateurs">{{utilisateur.prenom}}</option>
    
                </select>
            </mat-form-field>
        </form>
        
        <table class="table " >
            <thead>
            </thead>
            <tbody>
            <tr *ngFor="let suivi of suivisMapValues" class="doted-border fulWidth" [ngStyle]="{ 'color': suivi[suivi.length-1].couleurTexte, 'background-color': suivi[suivi.length-1].couleurFond }"
            class="fulWidth"> 
                <div *ngIf="suivi[suivi.length-1].idCandidat!=0 || suivi[suivi.length-1].idEntreprise!=0 || suivi[suivi.length-1].titre"
                class="fulWidth">
                    <td routerLink="/student/edit/{{suivi[suivi.length-1].idCandidat}}" *ngIf="suivi[suivi.length-1].idCandidat!=0 && suivi[suivi.length-1].idEntreprise==0" 
                    class="fifteen">
                        <div class="colored-cell rounded" [ngStyle]="{ 'color': 'black', 'background-color': color(suivi[suivi.length-1].datePrevueDisplay)}">
                            <div role="button" 
                            class="d-flex flex-raw justify-content-center  align-items-center text-white h-auto p-2">
                                <span class="pr-1"><mat-icon >search</mat-icon></span>
                                {{suivi[suivi.length-1].datePrevueDisplay}}
                            </div>
                        </div>
                    </td>
                    <td routerLink="/entreprise/edit/{{suivi[suivi.length-1].idEntreprise}}" *ngIf="suivi[suivi.length-1].idEntreprise!=0" 
                    class="fifteen">
                        <div class="colored-cell rounded" [ngStyle]="{ 'color': 'black', 'background-color': color(suivi[suivi.length-1].datePrevueDisplay)}">
                            <div role="button" class="d-flex flex-column justify-content-center  align-items-center">
                                <mat-icon >search</mat-icon>
                                {{suivi[suivi.length-1].datePrevueDisplay}}
                            </div>
                        </div>
                    </td>
                    <td routerLink="/suivis/edit/{{suivi[suivi.length-1].idSuivi}}" *ngIf="suivi[suivi.length-1].titre" 
                    class="fifteen">
                        <div class="colored-cell rounded" [ngStyle]="{ 'color': 'black', 'background-color': color(suivi[suivi.length-1].datePrevueDisplay)}">
                            <div role="button" class="d-flex flex-column justify-content-center  align-items-center">
                                <mat-icon >search</mat-icon>
                                {{suivi[suivi.length-1].datePrevueDisplay}}
                            </div>
                        </div>
                    </td>
                        
                    <td class="ten">{{suivi[suivi.length-1].prenomP}}</td>
                    <td class="fifteen">
                        <div class="d-flex flex-column justify-content-center  align-items-center" *ngIf="suivi[suivi.length-1].idCandidat!=0">
                            <mat-icon >school</mat-icon>
                            {{suivi[suivi.length-1].prenomEtud}} {{suivi[suivi.length-1].nomEtud}}
                        </div>
                        <div class="d-flex flex-column justify-content-center  align-items-center" *ngIf="suivi[suivi.length-1].idEntreprise!=0">
                            <mat-icon >business</mat-icon>
                            {{suivi[suivi.length-1].nomEntreprise}}
                        </div>
                        <div class="d-flex flex-column justify-content-center  align-items-center" *ngIf="suivi[suivi.length-1].titre">
                            <img height="20px" width="auto" src="assets/img/icone_tache.png">
                            {{suivi[suivi.length-1].titre}}
                        </div>
                                
                        
                    </td>
                    <td class="sixty">
                        <table class=" ">
                            <tr *ngIf="suivi.length>1" class="">
                                <div *ngIf="suivi[suivi.length-1].idEntreprise!=0"></div>
                                <b>{{suivi[0].dateFaite}}, par {{suivi[0].prenomF}} :</b>
                                {{suivi[0].commentaire?.length>200 ? suivi[0].commentaire?.slice(0, 201) + '...' : suivi[0].commentaire}}
                            </tr>
                            <tr *ngIf="suivi.length>2" class=""> 
                               <b>{{suivi[1].dateFaite}}, par {{suivi[1].prenomF}} :</b>
                                {{suivi[1].commentaire?.length>60 ? suivi[1].commentaire?.slice(0, 61) + '...' : suivi[1].commentaire}}
                            </tr>
                        </table>
                    </td>
                </div>
            </tr>
            
            </tbody>
        </table>

    </div>

</div>